
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/itsm-service-automation",
      function () {
        return require("private-next-pages/solutions/itsm-service-automation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/itsm-service-automation"])
      });
    }
  